import { render } from "./EyerwebExamImageTab.vue?vue&type=template&id=7fe1e879&scoped=true"
import script from "./EyerwebExamImageTab.vue?vue&type=script&lang=js"
export * from "./EyerwebExamImageTab.vue?vue&type=script&lang=js"

import "./EyerwebExamImageTab.vue?vue&type=style&index=0&id=7fe1e879&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe1e879"]])

export default __exports__